<template>
  <div class="detail-wrap">
    <el-form ref="complaint" :rules="rules" :model="complaint" :inline-message="true" class="demo-ruleForm">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}一键求助
          <span class="information" v-if="complaint.stat == 1">发布</span>
          <span class="information" v-if="complaint.stat == 2">跟进</span>
          <span class="information" v-if="complaint.stat == 3">完结</span>
        </div>
        <div class="fr">
<!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
<!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="doReply" v-if="complaint_follow && (complaint.stat ==1|| complaint.stat == 2) ">跟进</el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="dofinish" v-if="complaint_finish && complaint.stat == 2 ">完结</el-button>
        </div>
      </div>
      <div>

        <!-- 工单来源 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  单据号
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="complaint.orderNo" readonly clearable/>
                </td>

                <th>买家昵称</th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="complaint.userName" readonly clearable/>
                </td>

                <th>催促次数</th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="complaint.urgesNumbers" readonly clearable/>
                </td>
              </tr>
              <tr>
                <th>主订单号</th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="complaint.mainOrderNo" readonly clearable/>
                </td>

                <th>
                  服务单号
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="complaint.tmfworderid" readonly clearable/>
                </td>

                <th>求助单ID</th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="complaint.anomalyRecourseId" readonly clearable/>
                </td>
              </tr>
              <tr>
                <th>客户姓名</th>
                <td>
                  <el-input type="text" autocomplete="off" :v-model="complaint.soOrderDTO?complaint.soOrderDTO.userName:''" readonly clearable/>
                </td>

                <th>
                  客户电话
                </th>
                <td>
                  <el-input type="text" autocomplete="off" :v-model="complaint.soOrderDTO?complaint.soOrderDTO.userMobile:''" readonly clearable/>
                </td>

                <th>购买店铺</th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="complaint.buyShop" readonly clearable/>
                </td>
              </tr>
              <tr>
                <th>详细地址</th>
                <td colspan="5">
                  <el-input type="text"
                            autocomplete="off" v-model="complaint.address" readonly clearable/>
                </td>



              </tr>
              <tr>
                <th>问题分类</th>
                <td colspan="5">
                  <el-input type="text"
                            autocomplete="off" v-model="complaint.questionContent" readonly clearable/>
                </td>



              </tr>
              <tr>
                <th>
                  用户述求
                </th>
                <td colspan="5">
                  <el-input type="textarea"
                            :autosize="{ minRows: 4, maxRows: 8}" readonly autocomplete="off" v-model="complaint.appeals" readonly clearable/>
                  </td>
              </tr>
              <tr>
                <th>
                  回复信息
                </th>
                <td colspan="5">
                  <el-input type="textarea"
                            :autosize="{ minRows: 4, maxRows: 8}" readonly autocomplete="off" v-model="complaint.replyMessage" readonly clearable/>
                 </td>
              </tr>
              <tr>
                <th>
                  完结信息
                </th>
                <td colspan="5">
                  <el-input type="textarea"
                            :autosize="{ minRows: 4, maxRows: 8}" readonly autocomplete="off" v-model="complaint.finishMessage" readonly clearable/>
                </td>
              </tr>
              <tr v-if="!complaint.requestSource||complaint.requestSource==1">
                <th>
                  图片
                </th>
                <td>
                  <el-image v-if="complaint.complaintPic"
                            :src="complaint.complaintPic" fit="fit" :preview-src-list="srcList"
                            :initial-index="0"></el-image>
                  <el-image v-else>
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"
                         style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                    </div>
                  </el-image>
                </td>
              </tr>
              <tr>
                <th>提交时间</th>
                <td>
                  {{complaint.submitTime}}
                </td>
                <th>回复时间</th>
                <td>
                  {{complaint.replyTime}}
                </td>
                <th>完结时间</th>
                <td>
                  {{complaint.finishTime}}
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div v-if="complaint.requestSource==2" class="d-item">
            <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
              <div class="title first"><b>附件列表</b></div>
            </div>
            <div>
              <vxe-table style="margin-top: 0px;" :stripe="true"
                         :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                         :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                         show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"
                         @checkbox-all="selectChangeEvent" :data="complaint.tmComplaintOrderFileDTOList">
                <vxe-column type="checkbox" width="40" />
                <vxe-column field="fileName" title="附件名称" width="400">
                  <template #default="{ row }">
                    <!-- <a :href="row.fileUrl" :download="row.name">{{ row.fileName }}</a> -->
                    <span @click="openVideo(row.fileUrl)">{{ row.fileName }}</span>

                  </template>
                </vxe-column>

                <vxe-column title="操作" width="90">
                  <template #default="{ row }">
                    <!-- 下载 -->
                    <div>
                    </div>
                    <div>
                      <el-tooltip :enterable="false" effect="dark" content="下载" placement="top"
                                  popper-class="tooltip-skin">
                        <i @click="handleDownload(row.fileName, row.fileUrl)" class="el-icon-download"
                           style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                      </el-tooltip>

                      <el-tooltip :enterable="false" effect="dark" content="预览文件" placement="top"
                                  popper-class="tooltip-skin">
                        <i @click="openVideo(row.fileUrl)" class="el-icon-view"
                           style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                      </el-tooltip>
                    </div>
                  </template>
                </vxe-column>
              </vxe-table>
            </div>
          </div>
          <div>
          </div>
        </div>
      </div>
    </el-form>
    <OrderOperationDialog v-if="showOrderOperationDialog" @closeDialog="closeDialog"
                          :visiable.sync="showOrderOperationDialog" multi="true" :orderId="complaint.id" :requestSource="complaint.requestSource" :type="operationType" />

    <Preview v-if="showPreview" @closeD="closeD33" :visiable.sync="showPreview" :imgVisbleURL="imgVisbleURL" />

  </div>
</template>
<script>
import request from "@/router/axios";
import {mapGetters} from "vuex";
import {editPageMixins} from "@/mixins/tabChang";
import OrderOperationDialog from "@/views/workorder/business/tmcomplaint/OrderOperationDialog.vue";
import Preview from "@/views/dialogCommon/PreviewDialog.vue";
import api from "@/api/projectApi";
import store from "@/store";


export default {
  mixins: [editPageMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    initTableList: {
      type: Function,
      default: null
    }
  },
  components: {OrderOperationDialog,Preview,},
  data() {
    return {
      fileList: [],
      imgVisbleURL:'',
      showOrderOperationDialog:false,
      operationType:"",
      complaint_follow:false,
      complaint_finish:false,
      showPreview: false,
      complaint: {
        id: null,
        orderTypeName: null,
        isShowwx: 0,
        isShowIssue: 1,
        isShowSiteIssue: 0,
        code: null,
        seq: 0,
        tmComplaintOrderFileDTOList:[]
      },
      rules: {
        orderTypeName: [{required: true, prop: '来源名称', type: 'string', maxlength: 20}],
        code: [{required: false, prop: '编码', type: 'string', maxlength: 10}]
      },

      activeName: 'first',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    this.orderTypeSave = this.permissions['order_type_add']
    this.orderTypeEdit = this.permissions['order_type_edit']
  },
  mounted() {
    this.getData();
    this.complaint_follow = this.permissions['complaint_follow']
    this.complaint_finish = this.permissions['complaint_finish']
  },
  methods: {
    handleFileSuccess(res, file, fileList) {
      let url = res.data.url
      let fileName = file.name
      console.log(url, "url")
      console.log(fileName, "name")
      this.fileList.push({
        fileName: fileName,
        fileUrl: url
      })
      this.complaint.tmComplaintOrderFileDTOList = this.complaint.tmComplaintOrderFileDTOList || []
      this.complaint.tmComplaintOrderFileDTOList.push({
        fileName: fileName,
        fileUrl: url,
      })
      this.$mask.close()

    },
    upVideo() {
      this.$mask.open()

    },
    closeD33() {
      this.showPreview = false
    },
    closeDialog(type) {
      this.showOrderOperationDialog = false;
      if (type == 1) {
        this.$emit('editViewDataUpdate')// 需要刷新页面
      }
    },
    doReply(){
        this.operationType = 1
        this.showOrderOperationDialog = true
    },
    dofinish(){
      this.operationType = 2
      this.showOrderOperationDialog = true
    },
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        request({
          url: '/basic/tmComplaintOrder/get',
          method: 'post',
          data: {
            id: this._dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          console.log(response.data, "response");
          // this.complaint = response.data.objx || {};
          this.complaint = response.data.data;
          if(this.complaint.soOrderDTO) {s
            console.log("ACCC");

            this.complaint.buyShop = this.complaint.soOrderDTO.soOrderLineDTOList[0] === null ? null : this.complaint.soOrderDTO.soOrderLineDTOList[0].buyShop;
            this.complaint.address = this.complaint.soOrderDTO.userProvice + this.complaint.soOrderDTO.userCity + this.complaint.soOrderDTO.userCounty + (this.complaint.soOrderDTO.userTown === null ? '' : this.complaint.soOrderDTO.userTown) + this.complaint.soOrderDTO.userAddress;
          }
          console.log(this.complaint, "this.complaint赋值后");

        })
      }
    },
    selectChangeEvent(data) {
      console.log('选中数据', data)
      this.selectedData = data.records
    },
    openVideo(value) {
      this.imgVisbleURL = value
      this.showPreview = true
    },
    saveData() {
      this.$refs.complaint.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {

            this.$mask.open()

            var url = (this.isEdit ? `/basic/basOrderType/update` : `/basic/basOrderType/save`);
            this.$http({
              url: url,
              method: `post`,
              data: this.complaint,
              isLoading: true,
            }).then(() => {
              this.$message.success("保存成功！");
              this.goBackIndex()
              this.$mask.close()
            }).catch(() => {
              this.$message.error("保存失败！");
              this.$mask.close()
            });

            ;
          });
        }

      });

    },

    handleDownload(Vname, Vurl) {
      console.log(Vname, Vurl, "文件下载");
      // let url=file.type
      let url = Vurl
      let name = Vname

      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()
    },

  },
};

</script>
<style lang="scss" scoped>
// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  > span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

</style>
